const removeTrailingRequiredMark = (label) => {
    return label.replace(/\s*\*\s*$/, "").trim();
};

export const buildArtFieldLabel = (label, fieldMetadata) => {
    if (typeof label !== "string" || !fieldMetadata) {
        return label;
    }

    const baseLabel = removeTrailingRequiredMark(label);
    const isRequired = !!fieldMetadata.required;
    const showNotConsumedMessage =
        fieldMetadata.consumeArt === false ||
        fieldMetadata.consumeArt === 0;

    return `${baseLabel}${isRequired ? " *" : ""}${showNotConsumedMessage ? ` (Dato no consumido por la ART)` : ""}`;
};
